
import Vue from 'vue'
import SERVICES from '@/constants/services'
import { mapGetters } from 'vuex'
import { openChaport } from '@/utils/chaport'

export default Vue.extend({
  name: 'mobNavigationBar',
  data: () => ({
    navList: [
      { title: 'Мой аккаунт', to: { name: 'whitelistID' } },
      { title: 'Правовая информация', to: { name: 'whitelistIDLegalInformation' } }
    ]
  }),
  computed: {
    ...mapGetters('user', ['getIsAuthenticated', 'getUserData'])
  },
  methods: {
    redirectToAcceptor (): void {
      this.$store.commit('setAppIsRedirecting', true)
      window.open(sessionStorage.getItem('acceptor') ?? SERVICES.ACCEPTOR_BASE_URL, '_self')
    },
    showChat (): void {
      openChaport()
    }
  }
})
